import { MOCK_CONTACTS, FIPS_MAP } from './constants';

// Helper to check if a value is empty/invalid
export const isValueEmpty = (value) => {
  return value === undefined || value === null || value === '' || value === 'undefined' || (typeof value === 'string' && value.trim() === '');
};

// Create an empty contact object
export const createEmptyContact = () => ({
  name: '',
  phone: '',
  email: ''
});

// Mock SoftPro database search - Replace with actual API call later
export const searchSoftProContacts = async (searchField, searchValue, contactType) => {
  // Simulated delay to mimic API call
  await new Promise(resolve => setTimeout(resolve, 500));

  const contacts = MOCK_CONTACTS[contactType] || [];

  if (!searchValue.trim()) {
    return contacts;
  }

  // Filter based on search field and value
  const searchLower = searchValue.toLowerCase();
  return contacts.filter(contact => {
    const fieldValue = contact[searchField]?.toLowerCase() || '';
    return fieldValue.includes(searchLower);
  });
};

// Auto-fill FIPS code based on county
export const getFIPSCode = (county) => {
  return FIPS_MAP[county] || '';
};
